import React from "react";
import { TableCell, TableRow, Skeleton, Box } from "@mui/material";

const CartTableRowSkeleton = () => {
  return (
    <TableRow>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="text" width={30} height={20} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="text" width={60} height={20} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="text" width="90%" height={20} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="rectangular" width={70} height={30} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="text" width={60} height={20} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="rectangular" width="100%" height={30} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="rectangular" width="100%" height={30} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="rectangular" width="100%" height={30} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="text" width={40} height={20} />
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Skeleton variant="text" width={60} height={20} />
      </TableCell>
      <TableCell sx={{ p: 1, textAlign: 'center' }}>
        <Skeleton variant="circular" width={32} height={32} sx={{ margin: '0 auto' }} />
      </TableCell>
    </TableRow>
  );
};

export default CartTableRowSkeleton;

